var privacyPolicyTemplate = document.getElementsByClassName('privacy-policy-template');

var tabContainer = document.getElementsByClassName('privacy-policy-template__menu');

if (privacyPolicyTemplate[0]) {
    var sticky = privacyPolicyTemplate[0].offsetTop;
    window.onscroll = function() {myFunction()};
}

function myFunction() {
    if ((window.pageYOffset + 90) >= sticky) {
        privacyPolicyTemplate[0].classList.add("fixed")
    } else {
        privacyPolicyTemplate[0].classList.remove("fixed");
    }
}
if (tabContainer.length !== 0) {
    var tabs = tabContainer[0].getElementsByTagName('li');

    for (var i = 0; i < tabs.length; i++) {

        Array.prototype.forEach.call(tabs[i].children, child => {
            child.addEventListener('click', function() {
                child.closest('li').classList.add('active');
                // content[i].classList.add('active');
                event.preventDefault();

                var hash = this.hash;

                $('html, body').animate({
                    scrollTop: $(hash).offset().top - 184
                }, 0, function() {
                    window.location.hash = hash;
                })
            })

            var childID = $(child).attr('href');

            if ($(childID).length) {
                var childIDTop = $(childID).offset().top;
            }

            $(document).scroll(function() {
                var scrollPos = $(document).scrollTop();
                if (scrollPos + 200 > childIDTop) {
                    child.closest('li').classList.add('active');
                } else {
                    child.closest('li').classList.remove('active');
                }
              });
          });
    }
}
